import { createAsyncTypes } from 'utils/ActionCreator'

export const ATO_SENSITIVITY_LEVELS = {
  AGGRESSIVE: 1,
  BALANCED: 2,
  RELAXED: 3,
}

export const FEDERATION_SENSITIVITY_LEVELS = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
}

const ALLOW_LIST_LOCATION = 'Settings/Intelligence/Spam_Allow_List'

export const FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC = createAsyncTypes(
  'FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC',
  ALLOW_LIST_LOCATION
)

export const CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC = createAsyncTypes(
  'CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC',
  ALLOW_LIST_LOCATION
)

export const HANDLE_EMAIL_LIST_CHANGE = 'Settings/Intelligence/HANDLE_EMAIL_LIST_CHANGE'
export const HANDLE_SELECT_ALL_EMAILS = 'Settings/Intelligence/HANDLE_SELECT_ALL_EMAILS'

export const COMMUNITY_LEARN_MORE_LINK =
  'https://support.ironscales.com/hc/en-us/articles/360017335180-IRONSCALES-Community-Settings'

export const ATO_LEARN_MORE_LINK =
  'https://support.ironscales.com/hc/en-us/articles/4403248279314-Account-Takeover-ATO-Incidents'

export const ADAPTIVE_AI_SPAM_HYGIENE_LEARN_MORE_LINK =
  'https://support.ironscales.com/hc/en-us/articles/17729869652124-Adaptive-AI-Spam-Hygiene-Spam-Protection'
